import { render, staticRenderFns } from "./EditTagGroup.vue?vue&type=template&id=84ac99a0"
import script from "./EditTagGroup.vue?vue&type=script&lang=js"
export * from "./EditTagGroup.vue?vue&type=script&lang=js"
import style0 from "./EditTagGroup.vue?vue&type=style&index=0&id=84ac99a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports